export default __webpack_public_path__ + "static/RSP-symbol-bw-87d3a394cd4374bfb0a9b306edae3b4e.png";